<template>
	<el-menu :default-active="$route.path" class="el-menu-vertical-demo" background-color="#00072F" text-color="#ffffff"
	 active-text-color="#1abc9c" :collapse="isCollapse" :router="routerOpen"  ref="elMenu">
		<el-menu-item index="/home">
			<i class="el-icon-home"></i>
			<span slot="title">大数据平台中心</span>
		</el-menu-item>
		<el-menu-item v-if="isAdmin" index="/manager">
			<i class="el-icon-setting"></i>
			<span slot="title">系统管理</span>
		</el-menu-item>
		
		<!-- <el-menu-item index="/tab">
			<i class="el-icon-document-copy"></i>
			<span slot="title">tab选项卡</span>
		</el-menu-item> -->
		<el-submenu index="1">
			<template slot="title">
				<i class="el-icon-video-play"></i>
				<span>抖音大数据推广</span>
			</template>
			<el-menu-item index="/table">关键词分析</el-menu-item>
			<el-menu-item index="/table">同行博主获客</el-menu-item>
			<el-menu-item index="/table">精准视频获客</el-menu-item>
			<el-menu-item index="/douyin_aweme">视频库</el-menu-item>
			<el-menu-item index="/douyin_aweme_comment">客户库</el-menu-item>
			<!-- <el-menu-item index="/douyin_count">账号配置</el-menu-item> -->
		</el-submenu>
		<el-submenu index="1">
			<template slot="title">
				<i class="el-icon-date"></i>
				<span>小红书大数据推广</span>
			</template>
			<el-menu-item index="/xhs_table">全网获客</el-menu-item>
			<el-menu-item index="/note">笔记库</el-menu-item>
			<el-menu-item index="/xhs_note_comments">客户库</el-menu-item>
			<!-- <el-menu-item index="/xhs_count">账号配置</el-menu-item> -->
		</el-submenu>
		<el-submenu index="1">
			<template slot="title">
				<i class="el-icon-video-camera-solid"></i>
				<span>快手大数据推广</span>
			</template>
			<el-menu-item index="/ks_table">全网推广</el-menu-item>
			<el-menu-item index="/kuaishou_video">视频库</el-menu-item>
			<el-menu-item index="/kuaishou_video_comment">客户库</el-menu-item>
			<!-- <el-menu-item index="/ks_count">账号配置</el-menu-item> -->
		</el-submenu>
		<el-submenu index="1">
			<template slot="title">
				<i class="el-icon-camera"></i>
				<span>B站大数据推广</span>
			</template>
			<el-menu-item index="/bili_table">全网获客</el-menu-item>
			<el-menu-item index="/bilibili_video">视频库</el-menu-item>
			<el-menu-item index="/bilibili_video_comments">客户库</el-menu-item>
			<!-- <el-menu-item index="/bili_count">账号配置</el-menu-item> -->
		</el-submenu>
		<el-submenu index="1">
			<template slot="title">
				<i class="el-icon-coin"></i>
				<span>充值记录</span>
			</template>
			<el-menu-item index="/pay">充值历史</el-menu-item>
			
		</el-submenu>
		<!-- <el-menu-item index="/echart">
			<i class="el-icon-pie-chart"></i>
			<span slot="title">echart图表</span>
		</el-menu-item>
		<el-submenu index="2">
			<template slot="title">
				<i class="el-icon-rank"></i>
				<span>拖拽组件</span>
			</template>
			<el-menu-item index="/draggable">拖拽列表</el-menu-item>
			<el-menu-item index="/dialogDrag">拖拽弹框</el-menu-item>
		</el-submenu>
		<el-menu-item index="/international">
			<i class="el-icon-global"></i>
			<span slot="title">国际化功能</span>
		</el-menu-item>
		<el-submenu index="3">
			<template slot="title">
				<i class="el-icon-fake"></i>
				<span>错误处理</span>
			</template>
			<el-menu-item index="/permission">权限测试</el-menu-item>
			<el-menu-item index="/404">404</el-menu-item>
		</el-submenu>
		<el-submenu index="4">
			<template slot="title">
				<i class="el-icon-excel1"></i>
				<span>Excel</span>
			</template>
			<el-menu-item index="/excel/exportExcel">导出Excel</el-menu-item>
			<el-menu-item index="/excel/selectExcel">导出已选择项</el-menu-item>
			<el-menu-item index="/excel/mergerHeader">导出多级表头</el-menu-item>
			<el-menu-item index="/excel/uploadExcel">上传Excel</el-menu-item>
		</el-submenu>
		<el-menu-item index="/pdf">
			<i class="el-icon-pdf1"></i>
			<span slot="title">pdf下载</span>
		</el-menu-item>
		<el-menu-item index="/zip">
			<i class="el-icon-zip"></i>
			<span slot="title">导出zip</span>
		</el-menu-item>
		<el-menu-item index="/donate">
			<i class="el-icon-redbag"></i>
			<span slot="title">支持我吧</span>
		</el-menu-item> -->
	</el-menu>
</template>

<script>
	export default {
		props: ['isCollapse'],
		data() {
			return {
				routerOpen:true
			}
		},
		computed: {
			isAdmin() {
				return (localStorage.getItem('userRole') || '').toLowerCase() === 'admin'
			}
		},
	}
</script>

<style lang="stylus">
	.el-menu-vertical-demo:not(.el-menu--collapse) 
		width 250px
	
	.el-menu
		border-right none!important
</style>
